// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

//importReducers
import userInfoReducer from "./slices/userInfoReducer";
import jwtReducer from "./slices/jwtReducer";
import themeReducer from "./slices/themeSlice";
import modelReducer from "./slices/modelReducer";
import fieldReducer from "./slices/fieldReducer";
import sidebarReducer from "./slices/sidebarSlice";
import dashBoardReducer from "./slices/dashboard";
import componyInfoReducer from "./slices/compnayInfo";
import userReducer from "./slices/user"
import snackbarReducer from "./slices/snackbarSlice"
import recommendationReducer from "./slices/recommendation";
import addCompanyReducer from "./slices/addCompany";
import simulationReducer from "./slices/simulation";

const themePersistConfig = {
  key: "theme",
  storage,
  keyPrefix: "app-",
  whitelist: ["mode"], // Only persist the mode
};

const reducer = combineReducers({
  jwtState: jwtReducer,
  userInfoState: persistReducer(
    {
      key: "info",
      storage,
      keyPrefix: "user-",
      whitelist: ["userInfo"], // Only persist userInfo
    },
    userInfoReducer
  ),
  themeState: persistReducer(themePersistConfig, themeReducer),
  sidebarState: sidebarReducer,
  modelState: modelReducer,
  fieldState: fieldReducer,
  dashBoardState: dashBoardReducer,
  componyInfoState: componyInfoReducer,
  userState: userReducer,
  snackbar: snackbarReducer,
  recommendationState: recommendationReducer,
  addCompanyState: addCompanyReducer,
  simulationState: simulationReducer
});

export default reducer;
